// extracted by mini-css-extract-plugin
export default {"homepage":"Home_homepage__uF2cV"};